<template>
  <div>
    <div v-if="readonly">
      <div class="h44">
        车型
      </div>
      <ul class="cartypediv">
        <li>KGS</li>
        <li>CBM</li>
        <li>P/L</li>
        <li>P/L(小)</li>
      </ul>
    </div>
    <div v-if="!readonly" ref="cartypediv">
      <div class="h44" @click="open">{{ ttt }} <Icon type="md-car"></Icon>
      </div>

      <ul ref="cartypediv" class="cartypediv">
        <li>
          <InputNumber @on-change="put" size="small" v-model="result[0]"></InputNumber>
        </li>
        <li>
          <InputNumber @on-change="put" size="small" v-model="result[1]"></InputNumber>
        </li>
        <li>
          <InputNumber @on-change="put" size="small" v-model="result[2]"></InputNumber>
        </li>
        <li>
          <InputNumber @on-change="put" size="small" v-model="result[3]"></InputNumber>
        </li>
      </ul>
    </div>

    <Drawer width="340" class="my-drawer" title="车辆类型选择" v-model="show">
      <ul class="cartypelist">
        <li @click="change(item)" v-for="(item, index) in list" :key="index">
          <h4>{{ item.name }}</h4>
          <div>
            <span>满载规格：{{ item.kgs }}KGS，{{ item.cbm }}CBM，{{
              item.pl
            }}P/L</span>
          </div>
        </li>
      </ul>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["unit", "name", "readonly"],

  data() {
    return {
      ttt: "3T",
      kkk: "0,0,0",
      show: false,
      list: [],
      inputshow: false,
      result: [0, 0, 0, 0],
    };
  },
  methods: {
    open() {
      if (this.readonly) {
        return;
      }
      this.show = true;
      this.getList();
    },
    ff() {
      this.ttt = this.name;
      for (let i = 0; i < this.result.length; i++) {        
        this.result[i]=Number(this.unit[i]);//解决历史数据却残缺问题     
      }
      //this.kkk = this.unit.join(",");
    },
    change(v) {
      this.ttt = v.name;
      //this.kkk = v.kgs + "," + v.cbm + "," + v.pl + "," + v.pl1;
      this.show = false;
      this.result = [v.kgs, v.cbm, v.pl, 0];
      this.$emit("unit", this.result);
      this.$emit("name", this.ttt);
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/carType/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          var t = data[i].extend;
          for (const j in t) {
            data[i][j] = t == null ? "" : t[j];
          }
        }
        this.list = data;
      });
    },
    inputtc() {
      if (this.readonly) {
        return false;
      }
      this.inputshow = true;
      this.atob();
      // var t = this.atob.split("-");
    },
    put(){
      this.$emit("unit", this.result);
    },
    atob() {
      this.result = this.kkk.split(",");
    },
    btoa() {
      this.inputshow = false;
      this.$emit("unit", this.result);
    },
  },
  mounted() {
    this.ff();

  },
  watch: {
    unit() {
      this.ff();
    },
  },
};
</script>
<style>
.cartypelist li {
  cursor: pointer;
  padding: 5px;
  display: flex;
}

.cartypelist li:hover {
  background: #ebf5ff;
}

.cartypelist li h4 {
  font-weight: bold;
  margin-right: auto;
}

.h44:hover,
.p44:hover {
  cursor: pointer;
  color: red;
}

.cartypediv {
  width: 150px;
  padding: 0 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/baojiaCarType.vue